import { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../assets/icons/arrow-left.svg";
import background from "../../assets/images/background.png";
import { defaultPlan } from "../../price-id";
import { LOGIN_ROUTE, SETUP_ACCOUNT_STEP_ONE_ROUTE } from "../../routes";
import { emailSignUpHandler } from "../../services/firebase";
import PasswordField from "../common/password-field/password-field";

const Signup = ({ history, ...props }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [re_pass, setRePass] = useState("");

    const [error, setError] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    return (
        <div
            id="signup-page"
            style={{
                backgroundImage: `url(${background})`,
                minHeight: "100vh",
            }}
        >
            <div className="container pb-5">
                <div className="btn mt-3">
                    <BackIcon
                        width="32"
                        onClick={() => {
                            history.goBack();
                        }}
                    />
                </div>
                <h1 className="text-center text-light mt-5">
                    Create your account
                </h1>

                <div className="container-fluid">
                    {error !== "" && (
                        <div style={{ maxWidth: "32rem" }} className="alert alert-danger mx-auto my-4" role="alert">
                            {error}
                        </div>
                    )}
                    <form
                        className="mx-auto"
                        style={{ maxWidth: "32rem" }}
                        onSubmit={async (e) => {
                            e.preventDefault();
                            if (password === re_pass) {

                                setIsLoading(true);
                                setError("");

                                let result = await emailSignUpHandler(
                                    e,
                                    email,
                                    password
                                );

                                setIsLoading(false);

                                if (result.code === "auth/invalid-email") {
                                    setError("Please Enter a Valid Email Address");
                                    return false;
                                } 
                                else if(result.code === "auth/email-already-exists") {
                                    setError("Email already in Use");
                                    return false;
                                } else if(result !== true) {
                                    setError(result.message);
                                    return false;
                                } else {
                                    const subscriberInfo = {
                                        plan:
                                            props.location?.state?.plan ||
                                            defaultPlan,
                                    };
    
                                    history.push(SETUP_ACCOUNT_STEP_ONE_ROUTE, {
                                        subscriberInfo,
                                    });
                                }                   
                            } else {
                                setError("Passwords do not match");
                                return false ;
                            }
                        }}
                    >
                        <input
                            style={{ height: "3rem" }}
                            type="text"
                            placeholder="Email *"
                            className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        {/* <input
                            style={{ height: "3rem" }}
                            type="password"
                            placeholder="Password *"
                            className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        /> */}
                        <PasswordField 
                        setState={setPassword}
                        placeholder="Password *"
                        className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                        />
                        {/* <input
                            style={{ height: "3rem" }}
                            type="password"
                            placeholder="Confirm Password *"
                            className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                            onChange={(e) => {
                                setRePass(e.target.value);
                            }}
                            required
                        /> */}
                        <PasswordField 
                        setState={setRePass}
                        placeholder="Confirm Password *"
                        className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                        />
                        <div className="d-flex">
                            <div className="flex-fill"></div>

                            {isLoading ? (
                                <button
                                    style={{ height: "3rem" }}
                                    className="d-flex align-items-center btn btn-outline-light rounded-pill px-5 text-btn"
                                disabled>
                                    Signing up...
                                    <div className="spinner-border ms-4" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </button>
                            ) : (
                                <button
                                    style={{ height: "3rem" }}
                                    className=" btn btn-outline-light rounded-pill px-5 text-btn"
                                >
                                    Sign up
                                </button>
                            )}
                        </div>
                        <div className="d-flex justify-content-center">
                            <Link
                                to={LOGIN_ROUTE}
                                className="link text-white mt-5 text-body-1"
                            >
                                Or Login
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Signup;
